<div class="container">
  <div *ngIf="isLoading" class="row center">
    <div class="spinner-border text-danger" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div *ngIf="!isLoading" class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
      <div class="col-md-12 col-xs-12 mgb-10">
        <h2>All Active Events</h2>
      </div>
      <div class="col-md-12 col-xs-12 mgb-10">
        <h3>Cricket</h3>
      </div>
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="table table-bordered table-striped" style="margin-bottom: 35%;">
            <thead>
              <tr>
                <th class="center pd1p">#</th>
                <th>MKT ID</th>
                <!-- <th>Event ID</th> -->
                <th>Event Name</th>
                <th>Open Date</th>
                <th>Odds Source</th>
                <th>Fancy Source</th>
                <th>BM Source</th>
                <th>Fancy Active Type</th>
                <th>Score</th>
                <th>Add Type</th>

                <th>Action</th>
                <!-- <th *ngIf="level == '1'">Set Limit</th>
                <th>Update Header</th>
                <th *ngIf="level == '1'">Result</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of match; let i = index">
                <td class="center pd1p">{{ i+1 }}</td>
                <td>{{ data.marketId }} <br>{{ data.eventId }}</td>
                <!-- <td>{{ data.eventId }}</td> -->
                <td>{{ data.eventName }}</td>
                <td>{{ data.openDate }}</td>
                <!-- <td>
                  <select class="w100" id="odds{{ i }}">
                    <option value="">Select</option>
                    <option [selected]="data.oddsProvider == 'neeraj'" value='neeraj'>Betfair</option>
                  </select>
                  <br>
                  <button id="obtn{{ i }}" (click)="updateOdds(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Odds</button>
                  <div id="oprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="oerror{{ i }}">Please Select Odds First</span>
                </td> -->
                <td><span class="badge badgeback">{{ 'Betfair' | uppercase }}</span>
                </td>
                <td>
                  <select class="w100" id="fancy{{ i }}">
                    <option value="">Select</option>
                    <option [selected]="data.fancyProvider == 'diamond'" value='diamond'>Diamond</option>
                    <option [selected]="data.fancyProvider == 'sky'" value='sky'>Sky</option>
                    <option [selected]="data.fancyProvider == 'sk'" value='sk'>Sky3</option>
                    <option [selected]="data.fancyProvider == 'world'" value='world'>World</option>
                    <option [selected]="data.fancyProvider == 'tiger'" value='tiger'>Tiger</option>
                  </select>
                  <br>
                  <button id="fbtn{{ i }}" (click)="updateFancy(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Fancy</button>
                  <div id="fprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="ferror{{ i }}">Please Select Fancy First</span>
                </td>
                <!-- <td><span class="badge badgeback">{{ 'Sky' | uppercase }}</span>
                <td><span class="badge badgeback">{{ 'Sky' | uppercase }}</span> -->
                <td>
                  <select class="w100" id="bm{{ i }}">
                    <option value="">Select</option>
                    <option [selected]="data.bmProvider == 'diamond'" value='diamond'>Diamond</option>
                    <option [selected]="data.bmProvider == 'sky'" value='sky'>Sky</option>
                    <option [selected]="data.bmProvider == 'sk'" value='sk'>Sky3</option>
                    <option [selected]="data.bmProvider == 'world'" value='world'>World</option>
                    <option [selected]="data.bmProvider == 'tiger'" value='tiger'>Tiger</option>
                  </select>
                  <br>
                  <button id="bmbtn{{ i }}" (click)="updateBM(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update BookMaker</button>
                  <div id="bmprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="bmerror{{ i }}">Please Select BookMaker First</span>
                </td>
                <td>
                  <select class="w100" id="afancy{{ i }}">
                    <option [selected]="data.fancyAType == 'auto'" value='auto'>Auto</option>
                    <option [selected]="data.fancyAType == 'manual'" value='manual'>Manual</option>
                  </select>
                  <br>
                  <button id="afbtn{{ i }}" (click)="updateAFancy(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Type</button>
                  <div id="afprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
                <td *ngIf="isScore">
                  <select class="w100" id="score{{ i }}">
                    <option value="">Select</option>
                    <option *ngFor="let score3 of scoreList3" [selected]="score3.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score3.matchname }}", "cricexchageid": "{{ score3.cricexchageid }}"}'>
                      {{ score3.matchname}}</option>
                    <option *ngFor="let score1 of scoreList1" [selected]="score1.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score1.matchname }}", "cricexchageid": "{{ score1.cricexchageid }}"}'>
                      {{ score1.matchname}}</option>
                    <option *ngFor="let score2 of scoreList2" [selected]="score2.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score2.matchname }}", "cricexchageid": "{{ score2.cricexchageid }}"}'>
                      {{ score2.matchname}}</option>
                    <option *ngFor="let score4 of scoreList4" [selected]="score4.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score4.matchname }}", "cricexchageid": "{{ score4.cricexchageid }}"}'>
                      {{ score4.matchname}}</option>
                    <option *ngFor="let score2 of scoreList2" [selected]="score2.cricexchageid == data.scoreId"
                      value='{"type": "cricbuzz", "id": "{{ score2.cricexchageid }}"}'>{{ score2.matchname}}</option>
                  </select>
                  <br>
                  <button id="btn{{ i }}" (click)="updateScore(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Score</button>
                  <div id="process{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="error{{ i }}">Please Select Match First</span>
                </td>
                <td *ngIf="!isScore">
                  <div class="spinner-border2 text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </td>
                <td>
                  <select class="w100" id="addtype{{ i }}">
                    <option [selected]="data.addType == 'apna'" value='apna'>Apna</option>
                    <option [selected]="data.addType == 'all'" value='all'>All</option>
                  </select>
                  <br>
                  <button id="atbtn{{ i }}" (click)="updateAddType(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Type</button>
                  <div id="atprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="dropdown">
                    <button style="width: 160px;" class="btn btn-primary dropdown-toggle" type="button"
                      data-toggle="dropdown">Settings
                      <span class="caret"></span></button>
                    <ul class="dropdown-menu" style="padding-bottom: 0;">
                      <li class="li_border"><a routerLink="/fancy/{{ data.eventId }}">Get Fancy</a></li>
                      <!-- <li class="li_border" *ngIf="level == '1'"><a
                          routerLink="/setLimit/{{ data.eventId }}/{{ data.sportId }}">Set
                          Limit</a></li> -->
                      <li class="li_border"><a style="cursor:pointer;" (click)="removeMatch(i, data.eventId)">
                          Remove Match
                        </a>
                      </li>
                      <li class="li_border">
                        <a style="cursor:pointer;" (click)="setData(data.eventId, data.eventName)" data-toggle="modal"
                          data-target="#header" data-backdrop="static" data-keyboard="false">
                          Update Header
                        </a>
                      </li>
                      <li class="li_border"><a style="cursor:pointer;" (click)="deleteMatch(i, data.eventId)">
                          Delete Match
                        </a>
                      </li>
                    </ul>
                  </div>
                  <!-- <a routerLink="/fancy/{{ data.eventId }}"><button class="btn btn-danger fbtn">Get Fancy</button></a> -->
                </td>
                <!-- <td *ngIf="level == '1'"><a routerLink="/setLimit/{{ data.eventId }}"><button
                      class="btn btn-warning fbtn">Set Limit</button></a>
                </td> -->
                <!-- <td>
                  <div id="mprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                          <div class="spinner-border2 text-danger" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div> 
                </td> -->
                <!-- <td>
                  <button (click)="setData(data.eventId, data.eventName)" class="btn btn-info" data-toggle="modal"
                    data-target="#header" data-backdrop="static" data-keyboard="false">
                    Update Header
                  </button>
                </td> -->
                <!--td>
                  <select class="w100" id="result{{ i }}">
                    <option value="">Select</option>
                    <option value='{ "id": "98765", "name": "No Result" }'>No Result</option>
                    <option *ngFor="let runners of data.matchRunners"
                      value='{ "id": "{{ runners.selectionId }}", "name": "{{ runners.name }}" }'>{{ runners.name }}
                    </option>
                  </select>

                  <button id="rbtn{{ i }}" (click)="setResult(i, data.eventId, data.eventName)"
                    class="btn btn-s-md btn-info uscore">Set Result</button>
                  <div id="rprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="rerror{{ i }}">Please Select Selection First</span>
                </td-->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="header" aria-hidden="true" style="display: none;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button (click)="removeData()" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
        <h4 class="modal-title">Update Header</h4>
      </div>
      <div class="modal-body">
        <section class="panel panel-default">
          <header class="panel-heading font-bold"> {{ eventName }} </header>
          <div class="panel-body">
            <div class="form-group" style="width:100%">
              <input id="hname" style="width:100%" type="text" class="form-control" placeholder="Enter Header">
            </div>
            <div class="form-group" style="width:100%">
              <input id="team1" style="width:100%" type="text" class="form-control" placeholder="Enter Team 1">
            </div>
            <div class="form-group" style="width:100%">
              <input id="team2" style="width:100%" type="text" class="form-control" placeholder="Enter Team 2">
            </div>
            <div class="form-group" style="width:100%">
              <input id="team3" style="width:100%" type="text" class="form-control" placeholder="Enter Team 3">
            </div>
            <button (click)="updateHeader()" id="hbtn" type="button" class=" btn btn-success">Deposit</button>
            <div id="hprocess" class="row center" style="margin-top:5px;display:none;">
              <div class="spinner-border2 text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>